/**
 * Project status as the CREW read it (D-10 / O-1): a project they Start goes to
 * `on_site`, and to them that is simply "In progress" — the same word they use
 * for a started task. Finished-but-not-closed-out is "Finished" (Leo closes it
 * out). Supervisor screens keep the pipeline labels (`PROJECT_STATUS_LABELS`).
 */
import type { ProjectStatus } from '@vari-crew/schemas';

export const CREW_PROJECT_STATUS_LABEL: Record<ProjectStatus, string> = {
  requested: 'Requested',
  scheduled: 'Scheduled',
  en_route: 'En route',
  on_site: 'In progress',
  punch: 'Punch',
  pending_closeout: 'Finished',
  complete: 'Complete',
  blocked: 'Blocked',
  cancelled: 'Cancelled',
};

/** Statuses in which the crew are actively working the project. */
export const CREW_PROJECT_ACTIVE: ReadonlySet<ProjectStatus> = new Set<ProjectStatus>([
  'en_route',
  'on_site',
  'punch',
]);

/** Can the crew tap En route / Start / Finish from here? */
export function crewCanGoEnRoute(status: ProjectStatus): boolean {
  return status === 'scheduled';
}
export function crewCanStart(status: ProjectStatus): boolean {
  return status === 'scheduled' || status === 'en_route';
}
export function crewCanFinish(status: ProjectStatus): boolean {
  return status === 'on_site' || status === 'punch';
}

/** Mirrors the API's undo grace (2 minutes) for the Finish tap. */
export const PROJECT_FINISH_UNDO_GRACE_MS = 2 * 60 * 1000;
